// @flow
import * as React from 'react'
import { Helmet } from 'react-helmet'
import { useHistory } from 'react-router-dom'
import BreadcrumbButton from 'ui/atoms/BreadcrumbButton'
import PageWrapper from 'ui/atoms/PageWrapper'
import PageTitle from 'ui/molecules/PageTitle'

type Props = {
  action?: React.Node,
  centerContainer?: boolean,
  centerTitle?: boolean,
  children: React.Node,
  container?: boolean,
  fluid?: boolean,
  header?: React.Node,
  marginTop?: boolean,
  subtitle?: string,
  title?: string,
  titleComponent?: React.Node,
  withBackButton?: boolean,
  helmetTitle?: string,
  translate?: 'no',
}

function Page({
  action,
  centerContainer,
  centerTitle,
  children,
  container,
  fluid,
  header,
  marginTop,
  subtitle,
  title,
  titleComponent,
  withBackButton,
  helmetTitle,
  translate,
}: Props): React.Node {
  const history = useHistory()

  return (
    <>
      {withBackButton && (
        <BreadcrumbButton onClick={history.goBack}>Back</BreadcrumbButton>
      )}
      <PageWrapper
        $centerContainer={centerContainer}
        $fluid={fluid}
        $marginTop={marginTop}
        container={container}
      >
        {helmetTitle && (
          <Helmet>
            <title>{helmetTitle}/Zentake</title>
          </Helmet>
        )}
        {header ? header : null}
        {title || titleComponent ? (
          <PageTitle
            action={action}
            center={centerTitle}
            component={titleComponent}
            subText={subtitle}
            text={title}
            translate={translate}
          />
        ) : null}
        {children}
      </PageWrapper>
    </>
  )
}

export default Page
